import { useReducer } from "react";
export const commentReducer = (state, { type, payload }) => {
  switch (type) {
    case "doneComment":
      return state.map((element, index) => {
        if (index === payload.id) element.done = payload.done;
        return element;
      });
    default:
      return state;
  }
};

export const countReducer = (state, { type, payload }) => {
  switch (type) {
    case "setCommentValues":
      return { ...state, ...payload };
    case "decrementComment":
      return { ...state, ...state[payload].activeCount-- };
    case "incrementComment":
      return { ...state, ...state[payload].activeCount++ };
    default:
      return state;
  }
};

const paymentModelReducerState = {
  open: false,
  businessLocationId: null,
  clientId: null,
  payments: [],
};

export const usePaymentModalReducer = () => {
  const reducer = (state, { type, payload }) => {
    switch (type) {
      case "toogleModal":
        return { ...state, open: payload };
      case "setPaymentInfo":
        return {
          ...state,
          ...payload,
        };
      default:
        return state;
    }
  };
  return useReducer(reducer, paymentModelReducerState);
};
